import apiRoutes from 'router/routes/ApiRoutes';

import FetchHelpers from 'utils/FetchHelpers';

export default {
  async index(params) {
    const url = apiRoutes.staffMembersPath();
    return FetchHelpers.get(url, params);
  },
  async show(id, params) {
    const url = apiRoutes.staffMemberPath(id);
    return FetchHelpers.get(url, params);
  },
  async delete(id, params) {
    const url = apiRoutes.staffMemberPath(id);
    return FetchHelpers.delete(url, params);
  },
  async update(id, params) {
    const url = apiRoutes.staffMemberPath(id);
    return FetchHelpers.put(url, params);
  },
  async create(params) {
    const url = apiRoutes.staffMembersPath();
    return FetchHelpers.post(url, params);
  },
};
